import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { CalculationMethod } from "../../common/calculation-method";
import { AddressDTO, DocumentBuyerDTO, DocumentClientDTO } from "../../document/dto/document-client.dto";
import { DocumentExchangeRateDTO } from "../../document/dto/document-exchange-rate.dto";
import { DocumentPaymentDTO } from "../../document/dto/document-payments.dto";
import { KsefSendSubmissionMode } from "../../ksef/ksef-send-submission-mode";
import { SaleDocumentKind } from "../sale-document-kind";
import { SplitPaymentState } from "../split-payment-state";
import { SaleDocumentAdditionalDataDTO } from "./sale-document-additional-data.dto";
import { RateNP } from "../rate-np";

export class SaleDocumentDTO {
	public advanceReturnValue?: number;
	public advanceValue?: number;
	public bankAccountId: number;
	public baseCurrencyBankAccountId: number;
	@Type(() => DocumentBuyerDTO) public buyer: DocumentBuyerDTO;
	public calculationMethod: CalculationMethod;
	public cashBasis: boolean;
	@Type(() => DocumentClientDTO) public client: DocumentClientDTO;
	public communityTransactionId: number;
	public currencyId: number;
	@Type(() => AddressDTO) public deliveryAddress: AddressDTO;
	@Transform(transformDTODate, { toClassOnly: true }) public deliveryDate?: Date;
	public documentNumber: string;
	@Transform(transformDTODate, { toClassOnly: true }) public dueDate: Date;
	@Type(() => DocumentExchangeRateDTO) public exchangeRate: DocumentExchangeRateDTO;
	public favourite: boolean;
	public id: number;
	@Transform(transformDTODate, { toClassOnly: true }) public issueDate: Date;
	@Transform(transformDTODate, { toClassOnly: true }) public goodsIssueDate: Date | null;
	public issuedByVatPayer: boolean;
	public issuer: string;
	public kind: SaleDocumentKind;
	public jpkVatDocumentGroups: string[];
	public jpkVatProductGroups: string[];
	public invoiceToReceipt?: boolean;
	public note: string;
	public paymentMethodId?: number;
	@Type(() => DocumentPaymentDTO) public payments: DocumentPaymentDTO[];
	public recipient: string;
	public splitPayment: SplitPaymentState;
	@Transform(transformDTODate, { toClassOnly: true }) public taxLiabilityDate?: Date;
	public transactionLocation: string;
	public wstoShipmentCountryId?: number;
	public wstoConsumerCountryId?: number | null;
	@Transform(transformDTODate, { toClassOnly: true }) public orderDate?: Date | null;
	public wstoAdditionalInformation: string;
	public version: string;
	public relatedInventoryDocuments: { id: number, version: string }[];
	public duplicatePreventionId: string;
	public ksefSubmissionMode: KsefSendSubmissionMode;
    public orderExternalId?: string;
	@Type(() => SaleDocumentAdditionalDataDTO) public additionalData?: SaleDocumentAdditionalDataDTO;
	@Transform(({ value, obj }) => value ?? (obj as { rateNp?: RateNP | null }).rateNp ?? null, { toClassOnly: true }) public rateNP: RateNP | null;
	public reverseCharge: boolean | null;
}
